import * as Sentry from "@sentry/node";

export function initSentry() {
  const sentryDSN = process.env["SENTRY_DSN"];

  if (sentryDSN) {
    Sentry.init({
      environment: process.env.NODE_ENV ?? "production",
      dsn: sentryDSN,
      sendDefaultPii: true,
      tracesSampleRate: 1.0,
    });
  }
}
